import React from 'react'
import Text from '../NewText'
import { RatingStars } from '@/stories/strapi-4/atoms-components/rating-star/StrapiV4RatingStar'

const AppRating = () => {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex space-x-4">
        <div className="ml-2 flex w-32 cursor-pointer items-center gap-2 md:w-40">
          <Text appearance="subtitle2">4.7</Text>
          <RatingStars fullStars={4} hasHalfStar={true} />
        </div>
        <div className="ml-2 flex w-32 cursor-pointer items-center gap-2 md:w-40">
          <Text appearance="subtitle2">4.6</Text>
          <RatingStars fullStars={4} hasHalfStar={true} />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Text appearance="subtitle1" addClassName="text-brand-green-dark">
          2 crore+ Downloads.
        </Text>
        <Text appearance="subtitle1">3 Lakh+ reviews</Text>
      </div>
    </div>
  )
}

export default AppRating
